export default {
  props: {
    shopPackage: Object,
    fee: Number,
    buttonLoading: Boolean,
    price: String,
    bonusAmount: Number,
  },
  data() {
    return {};
  },
  computed: {},
  watch: {},
  methods: {},
  mounted() {
  }
};
